import Vue from 'vue'
import Router from 'vue-router'
import lazyLoading from './lazyLoading'
import layout from '@/views/layout/index'
Vue.use(Router)

const appRouters = [
  {
    path: '/',
    redirect: '/order/index'
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    redirect: '/dashboard/index',
    component: layout,
    children: [
      {
        path: 'index',
        name: 'index',
        component: () => import('@/views/index/index'),
        meta: {
          name: 'index',
          title: '首页',

          auth: true,
          isTab: true
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login'),
    meta: {
      name: 'login',
      title: '登录',
      requiresAuth: false,
      isTab: false,
      fullscreen: true
    }
  },
  {
    path: '/address',
    name: 'address',
    component: layout,
    redirect: '/address/index',
    children: [
      {
        path: 'index',
        name: 'addressindex',
        component: () => import('@/views/address/index'),
        meta: {
          name: 'addressindex',
          title: '地址管理',
          requiresAuth: true,
          isTab: true,
          fullscreen: false
        }
      }
    ]
  },
  {
    path: '/profile',
    component: layout,
    redirect: '/profile/index',
    children: [
      {
        path: 'index',
        name: 'profileindex',
        component: () => import('@/views/profile/index'),
        meta: {
          name: 'profileindex',
          title: '个人中心',
          isTab: true,
          auth: true,
          fullscreen: false
        }
      }
    ]
  },
  {
    path: '/order',
    component: layout,
    redirect: '/order/index',
    children: [
      {
        path: 'index',
        name: 'order',
        component: () => import('@/views/order/index'),
        meta: {
          name: 'order',
          title: '期刊订阅',

          isTab: true,
          auth: true,
          fullscreen: false
        }
      },
      {
        path: 'detail',
        name: 'orderDetail',
        component: () => import('@/views/order/detail'),
        meta: {
          name: 'orderDetail',
          title: '期刊订阅详情',

          isTab: true,
          auth: true,
          fullscreen: false
        }
      },
      {
        path: 'pay',
        name: 'pay',
        component: () => import('@/views/order/pay'),
        meta: {
          name: 'pay',
          title: '期刊订阅支付',

          isTab: true,
          auth: true,
          fullscreen: false
        }
      }
    ]
  },
  {
    path: '/ordercheck',
    component: layout,
    redirect: '/ordercheck/index',
    children: [
      {
        path: 'index',
        name: 'ordercheckindex',
        component: () => import('@/views/orderCheck/index'),
        meta: {
          name: 'ordercheckindex',
          title: '订单查询',
          isTab: true,
          auth: true,
          fullscreen: false
        }
      },
      {
        path: 'invoice',
        name: 'ordercheckinvoice',
        component: () => import('@/views/orderCheck/invoice'),
        meta: {
          name: 'ordercheckinvoice',
          title: '合开发票',
          isTab: true,
          auth: true,
          fullscreen: false
        }
      },
      {
        path: 'detail',
        name: 'ordercheckdetail',
        component: () => import('@/views/orderCheck/detail'),
        meta: {
          name: 'ordercheckdetail',
          title: '订单详情',
          isTab: true,
          auth: true,
          fullscreen: false
        }
      },
      {
        path: 'dispatchDetail',
        name: 'dispatchdetail',
        component: () => import('@/views/orderPartSend/detail'),
        meta: {
          name: 'dispatchdetail',
          title: '分寄订单详情',
          isTab: true,
          auth: true,
          fullscreen: false
        }
      }
    ]
  },
  {
    path: '/logiccheck',
    redirect: '/logiccheck/index',
    component: layout,
    children: [
      {
        path: 'index',
        name: 'logiccheckindex',
        component: () => import('@/views/logicCheck/index'),
        meta: {
          name: 'logiccheckindex',
          title: '物流查询',
          auth: true,

          isTab: true,
          fullscreen: false
        }
      }
    ]
  },
  {
    path: '/message',
    redirect: '/message',
    component: layout,
    children: [
      {
        path: 'index',
        name: 'message',
        component: () => import('@/views/message/index'),
        meta: {
          name: 'message',
          title: '通讯员',
          auth: true,

          isTab: true,
          fullscreen: false
        }
      }
    ]
  },
  {
    path: '/orderpartsend',
    redirect: '/orderpartsend/index',
    component: layout,
    children: [
      {
        path: 'index',
        name: 'orderpartsend',
        component: () => import('@/views/orderPartSend/new'),
        meta: {
          name: 'orderpartsend',
          title: '分寄订阅',
          auth: true,
          isTab: true,
          fullscreen: false
        }
      }
    ]
  },
  {
    path: '/batchorder',
    redirect: '/orderpartsend/batchorder',
    component: layout,
    children: [
      {
        path: '/batchorder',
        name: 'batchorder',
        component: () => import('@/views/orderPartSend/batchOrder'),
        meta: {
          name: 'batchorder',
          title: '批量订阅',
          auth: true,
          isTab: true,
          fullscreen: false
        }
      }
    ]
  },
  {
    path: '/TL',
    redirect: {
      path: '/login',
      query: {
        catid: 3430
      }
    }
  }

// {
//   path: '/404',
//   name: '404',
//   title: '404未找到',
//   component: () => import('@/views/error/404'),
//   meta: {
//     name: '404',
//     title: '404未找到',
//     show: 0,
//     requiresAuth: false,
//     isTab: false,
//   }
// },
// {
//   path: '*',
//   redirect: {
//     name: '404'
//   }
// }
]

export default new Router({
  mode: 'hash',
  linkActiveClass: 'link-active',
  routes: appRouters // 默认只有登陆
})
